import React, { useContext } from 'react';
import { FooterContainer, FooterImage } from './styled';
import {
  footerAddress,
  footerCNPJ,
  footerCopyright,
  footerRightsReserved,
} from '../../utils/constants';
import logo from '../../assets/images/logo-caixaseguradora.png';
import Chat from '../Chat';
import { AppContext } from '../../context';

const Footer = ({ showFooterChat }) => {
  const { ibcLogged } = useContext(AppContext);
  return (
    <FooterContainer data-blocoid="Bloco: Footer">
      <FooterImage src={logo} alt="Caixa Seguradora" />
      <article>
        <p>{footerAddress}</p>
        <p>{footerCNPJ}</p>
      </article>
      <article>
        <p className="copyright">{footerCopyright}</p>
        <p className="copyright">{footerRightsReserved}</p>
      </article>
      {showFooterChat && !ibcLogged && <Chat />}
    </FooterContainer>
  );
};

export default Footer;
